import React, { useState } from "react";

const DirectTest = () => {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const testDirectly = async () => {
    setLoading(true);
    setResult(null);
    
    console.log("🔥 DIRECT TEST: Starting direct API test");
    
    try {
      const url = "http://localhost:5000/cart/68ded148cbfe892dc87f3c45";
      console.log("🔥 DIRECT TEST: Fetching from:", url);
      
      const response = await fetch(url);
      console.log("🔥 DIRECT TEST: Response:", response);
      console.log("🔥 DIRECT TEST: Status:", response.status);
      console.log("🔥 DIRECT TEST: OK:", response.ok);
      
      const data = await response.json();
      console.log("🔥 DIRECT TEST: Data:", data);
      
      setResult({
        success: true,
        status: response.status,
        data: data,
        itemsCount: data?.items?.length || 0
      });
    } catch (error) {
      console.error("🔥 DIRECT TEST: Error:", error);
      setResult({
        success: false,
        error: error.message
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-red-500 text-white p-6 rounded-lg mb-6">
          <h1 className="text-3xl font-bold">🔥 DIRECT API TEST</h1>
          <p>Testing direct API call to backend</p>
        </div>
        
        <div className="bg-white p-6 rounded-lg shadow-md mb-6">
          <button
            onClick={testDirectly}
            disabled={loading}
            className="px-6 py-3 bg-red-500 text-white rounded-lg hover:bg-red-600 disabled:opacity-50 text-lg font-bold"
          >
            {loading ? 'Testing...' : '🔥 TEST API DIRECTLY'}
          </button>
        </div>

        {result && (
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="text-xl font-semibold mb-4">Test Results:</h3>
            
            {result.success ? (
              <div className="text-green-600">
                <p><strong>✅ SUCCESS!</strong></p>
                <p><strong>Status:</strong> {result.status}</p>
                <p><strong>Items Count:</strong> {result.itemsCount}</p>
                
                {result.data && (
                  <div className="mt-4">
                    <h4 className="font-semibold mb-2">Response Data:</h4>
                    <pre className="bg-gray-100 p-4 rounded text-sm overflow-auto max-h-96">
                      {JSON.stringify(result.data, null, 2)}
                    </pre>
                  </div>
                )}
              </div>
            ) : (
              <div className="text-red-600">
                <p><strong>❌ FAILED!</strong></p>
                <p><strong>Error:</strong> {result.error}</p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default DirectTest;
